import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useAuth } from '../auth/AuthContext';

/**
 * Sticky banner suggesting 2FA enrollment for admin accounts that
 * haven't enrolled yet. Same logic and copy as the dashboard variant;
 * dismissable for the current page-load only (state never persists
 * to localStorage) and explicitly reset on every route change so the
 * suggestion reappears on the next navigation until the admin
 * actually enrols.
 */
export function TwoFactorNudgeBanner() {
  const { user } = useAuth();
  const location = useLocation();
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    setDismissed(false);
  }, [location.pathname]);
  if (!user || user.twoFactorEnabled || dismissed) return null;
  if (location.pathname === '/settings/account') return null;
  return (
    <div className="bg-amber-50 border-b border-amber-200">
      <div className="px-8 py-2 flex items-center justify-between gap-4">
        <div className="text-sm text-amber-900">
          Protect your account with two-factor authentication.{' '}
          <Link to="/settings/account" className="font-semibold underline">
            Set it up
          </Link>
          .
        </div>
        <button
          type="button"
          onClick={() => setDismissed(true)}
          className="text-amber-700 hover:text-amber-900 text-sm"
          aria-label="Dismiss"
        >
          ✕
        </button>
      </div>
    </div>
  );
}
